<div class="container mt-4">
    <span>Estimado <strong>{{nombreUsuario}}</strong></span>

    <br><br>

    <span>Solicitamos tu apoyo con el diligenciamiento de la siguiente encuesta, que nos permitirá evaluar el nivel de satisfacción con servicio de transporte prestado, para mejora continua de nuestro servicio</span>

    <br><br>
    
    <div class="d-flex flex-column container" id="contenedor_preguntas">
        <div class="row" *ngFor="let pregunta of preguntasEncuesta; let i = index">
            <label class="mb-2 mt-3">{{i+1}} {{pregunta.vcNombre}}</label>
            
            <span class="ms-2 respuestas" [id]="'Respuesta_'+i" *ngFor="let respuesta of respuestasEncuesta">{{respuesta.vcIcono}} 
                <input type="radio" [name]="'pregunta'+i" [id]="'p'+i+'_'+respuesta.iValor" 
                    [value]="respuesta.iValor" 
                    (change)="guardarRespuesta(i, respuesta.id)">
                <label [for]="'p'+i+'_'+respuesta.iValor" class="ms-2">{{respuesta.vcNombre}}</label>
            </span>
        </div>

        <br>

        <div class="col-md-12 pe-4">
            <label for="obs" class="form-label">Observaciones o sugerencias</label>
            <textarea class="form-control" [(ngModel)]="dataObservaciones" rows="3" id="obs" name="observaciones" maxlength="800"></textarea>
        </div>

        <br><br>

        <div class="col-md mb-5">
            <button type="button" class="btn btn-secondary col-md-2" (click)="onEnviarEncuesta()">
                ENVIAR
            </button>
        </div>
    </div>
</div>